import React from "react";
import { DeleteConfirmationModalProps } from "../types/branch";
import { ModalWrapper } from "../../../../components/ModalWrapper";
import CommonButtons from "../../../../components/CommonButtons";

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({ open, onClose, onConfirm, branchName }) => {
  if (!open) return null; // Don't render if modal is closed

  return (
    <ModalWrapper title="Delete Confirmation" onClose={onClose} width="max-w-md" className="shadow-lg">
      <div className="text-center space-y-4">
        <p className="font-bold">Branch name: {branchName}</p>
        <p>Are you sure you want to delete this branch?</p>
      </div>

      <div className="flex justify-end gap-4 mt-6">
        <CommonButtons className="w-36 h-10" label="Cancel" variant="outlineDanger" onClick={onClose} />
        <CommonButtons className="w-36 h-10" label="Confirm" onClick={onConfirm} />
        
      </div>
    </ModalWrapper>
  );
};

export default DeleteConfirmationModal;
